import { useMutation } from '@tanstack/react-query';
import giftClient from '../../../api/gift';

interface UseUploadGiftSenderImageOptions {
  setUrl?: (url: string) => void;
  onSuccess?: (url: string) => void;
  onError?: () => void;
}

const useUploadGiftSenderImage = ({
  setUrl,
  onSuccess,
  onError,
}: UseUploadGiftSenderImageOptions) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['upload-gift-sender-image'],
    mutationFn: (file: string) => giftClient.uploadSenderImage(file),
  });

  const handleFileSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      onError?.();
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      try {
        setUrl?.(reader.result as string);
        const { url } = await mutateAsync(reader.result as string);
        setUrl?.(url);
        onSuccess?.(url);
      } catch {
        onError?.();
      }
    };
    reader.onerror = () => {
      setUrl?.('');
      onError?.();
    };
    reader.onabort = () => {
      setUrl?.('');
      onError?.();
    };
    reader.readAsDataURL(file);
  };

  return { handleFileSelection, isPending };
};

export default useUploadGiftSenderImage;
